import SideModal from "components/SideModal";
import { useAuth } from "contexts/AuthContext";
import { useTranslation } from "contexts/i18nContext";
import { useToast } from "contexts/ToastContext";
import { ChangeEvent, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  addFurtherInvestigation,
  addInvestigation,
  editComplaint,
} from "services/prosecutorDecipilineService";
import { Complaints } from "types";
import { LoadingIcon } from "utils/constant";
import {
  COMPLIANT_STATUS,
  INVESTIGATION_STATUS,
  PROSECUTOR_DECISION_TYPE,
  PROSECUTOR_DECISION_TYPE2,
} from "utils/constantValues";

interface DecisionModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  complaintData: Complaints;
  onRefresh: any;
  addMoreDecision?: boolean;
}

export default function AddDecisionModal({
  isOpen,
  setIsOpen,
  complaintData,
  onRefresh,
  addMoreDecision = false,
}: DecisionModalProps) {
  const { user } = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [formState, setFormState] = useState({
    decision_type: PROSECUTOR_DECISION_TYPE?.FRAME_CHARGE,
    decision_summary: "",
    charge_summary: "",
    decision_date: "",
    charge_article: "",
    status: INVESTIGATION_STATUS?.PENDING,
    complaint: null,
    files: [] as File[],
  });
  const fileInputRef = useRef<HTMLInputElement>(null);

  // const [adminUnitData, setAdminUnitData] = useState<AdminUnit>();
  // const [childAdminUnit, setChildAdminUnit] = useState<any>([]);
  // const [selectedAdminUnit, setSelectedAdminUnit] = useState<any>();

  // useEffect(() => {
  //   const loadAdminUnitDetail = async () => {
  //     try {
  //       const adminUnitDetail = await fetchAdminUnitDetail(
  //         user?.admin_unit,
  //         user?.access,
  //       );
  //       setAdminUnitData(adminUnitDetail);
  //     } catch (err) {
  //       console.error("Failed to load admin unit detail:", err);
  //     }
  //   };
  //   loadAdminUnitDetail();
  // }, [user]);

  // useEffect(() => {
  //   const loadChildAdminUnit = async () => {
  //     try {
  //       const adminUnitDetail = await fetchChildAdminUnits(
  //         adminUnitData?.uu_id || "",
  //         user?.access,
  //       );
  //       setChildAdminUnit(adminUnitDetail?.units);
  //     } catch (err) {
  //       console.error("Failed to load child admin units:", err);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  //   adminUnitData?.uu_id && loadChildAdminUnit();
  // }, [adminUnitData, user?.access]);

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormState((prev) => ({
        ...prev,
        files: [...prev.files, ...Array.from(e.target.files as FileList)],
      }));
    }
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);

    const data = new FormData();
    if (PROSECUTOR_DECISION_TYPE2.FRAME_CHARGE === formState?.decision_type)
      data.append("charge_documents", formState?.files[0] || "");
    else
      data.append("prosecutor_decision_documents", formState?.files[0] || "");
    data.append("prosecutor_decision_type", formState.decision_type);
    data.append("investigation_start_date", formState.decision_date);
    data.append(
      "prosecutor_decision_date",
      PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE === formState.decision_type
        ? formState.decision_date
        : "",
    );
    data.append(
      "prosecutor_decision_summary",
      PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE === formState.decision_type
        ? formState.decision_summary
        : "",
    );
    data.append(
      "status",
      PROSECUTOR_DECISION_TYPE2.FRAME_CHARGE === formState?.decision_type
        ? INVESTIGATION_STATUS.BACK_TO_PROSECUTOR
        : formState.status,
    );

    data.append(
      "charge_summary",
      PROSECUTOR_DECISION_TYPE2?.FRAME_CHARGE === formState.decision_type
        ? formState?.charge_summary
        : "",
    );
    data.append("charge_article", formState?.charge_article || "");

    data.append(
      "assigned_prosecutor",
      complaintData?.assigned_prosecutor || "",
    );
    data.append(
      "user_id_assigned_prosecutor",
      complaintData?.user_id_accused_prosecutor_name || "",
    );
    data.append(
      "accused_prosecutor_name",
      complaintData?.accused_prosecutor_name || "",
    );
    data.append(
      "user_id_accused_prosecutor_name",
      complaintData?.user_id_accused_prosecutor_name || "",
    );
    data.append(
      "accused_prosecutor_org_id",
      complaintData?.accused_prosecutor_org_id || "",
    );
    data.append(
      "accused_prosecutor_admin_unit_id",
      complaintData?.accused_prosecutor_admin_unit_id || "",
    );
    data.append("admin_unit_id", complaintData?.admin_unit_id || "");
    data.append("org_id", complaintData?.org_id || "");
    data.append("complaint", String(complaintData?.uu_id));

    const isFormData = true;

    try {
      const res = await addInvestigation(data, isFormData);

      // if (
      //   (formState.decision_type === "out of jurisdiction forward to zone" ||
      //     formState.decision_type ===
      //       "Forwarded to zone for further investigation") &&
      //   res?.investigation?.uu_id
      // ) {
      //   await editComplaint({
      //     ...complaintData,
      //     status: COMPLIANT_STATUS.PENDING,
      //     admin_unit_id: selectedAdminUnit,
      //     assigned_prosecutor:
      //       formState.decision_type ===
      //       "Forwarded to zone for further investigation"
      //         ? ""
      //         : undefined,
      //     user_id_assigned_prosecutor:
      //       formState.decision_type ===
      //       "Forwarded to zone for further investigation"
      //         ? ""
      //         : undefined,
      //     decision_type: "",
      //   });
      //   await addFurtherInvestigation({
      //     comment: formState.decision_summary,
      //     investigation: res?.investigation?.uu_id,
      //   });
      //   navigate(-1);
      // } else {
      await editComplaint({
        ...complaintData,
        status: COMPLIANT_STATUS.DRAFT_CHARGE,
      });
      // }

      if (
        (formState.decision_type === "out of jurisdiction forward to zone" ||
          formState.decision_type ===
            "Forwarded to zone for further investigation") &&
        res?.investigation?.uu_id
      ) {
        await addFurtherInvestigation({
          comment: formState.decision_summary,
          investigation: res?.investigation?.uu_id,
        });
      }

      onRefresh();
      setIsOpen(false);
      showToast(t("prosecutorDecisionRecorded"), "success");
      setFormState({
        decision_type: PROSECUTOR_DECISION_TYPE?.FRAME_CHARGE,
        decision_summary: "",
        decision_date: "",
        status: INVESTIGATION_STATUS.PENDING,
        complaint: null,
        charge_summary: "",
        charge_article: "",
        files: [] as File[],
      });
    } catch (err: any) {
      console.error("Submission error:", err);
      showToast(t("failedToSubmitProsecutorDecision"), "error");
    } finally {
      setLoading(false);
    }
  };

  const triggerFileInput = () => {
    fileInputRef.current?.click();
  };

  const removeFile = (index: number) => {
    setFormState((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  if (!isOpen) return null;

  return (
    <SideModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title={t("prosecutorDecisionRegistry")}
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* <div className="text-sm text-gray-500">Formal Recording of Prosecutorial Determination</div> */}

        {/* Decision Details Section */}
        <section className="space-y-4">
          <div className="flex items-center">
            <div className="h-5 w-1 bg-red-700 rounded-r mr-3"></div>
            <h3 className="text-base font-semibold text-gray-800">
              {t("decisionDetails")}
            </h3>
          </div>

          <div className="space-y-4 pl-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {t("decisionType")} <span className="text-red-600">*</span>
              </label>
              <select
                required
                className="w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                name="decision_type"
                value={formState.decision_type}
                onChange={handleChange}
              >
                <option value="" disabled>
                  {t("selectDecisionType")}
                </option>
                {Object.values(PROSECUTOR_DECISION_TYPE2)?.map((list) => (
                  <option key={list} value={list}>
                    {list}
                  </option>
                ))}
                {addMoreDecision && (
                  <option value={"out of jurisdiction forward to zone"}>
                    {t("outOfJurisdictionForwardToZone")}
                  </option>
                )}
                {addMoreDecision && (
                  <option value={"Forwarded to zone for further investigation"}>
                    {t("forwardedToZoneForFurtherInvestigation")}
                  </option>
                )}
              </select>
            </div>

            {/* Jurisdiction Transfer */}
            {/* {(formState?.decision_type ===
              "out of jurisdiction forward to zone" ||
              formState?.decision_type ===
                "Forwarded to zone for further investigation") &&
              adminUnitData?.hierarchy_level?.name ===
                HIERARCHY_LEVELS?.REGIONAL && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("forwardToZone")} <span className="text-red-600">*</span>
                  </label>
                  <select
                    required
                    className="w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    value={selectedAdminUnit || ""}
                    onChange={(e) => setSelectedAdminUnit(e.target.value)}
                  >
                    <option value="">{t("selectZoneAdministration")}</option>
                    {childAdminUnit?.map((list: any) => (
                      <option key={list.uu_id} value={list.uu_id}>
                        {list?.unit_name}
                      </option>
                    ))}
                  </select>
                  <p className="text-xs text-gray-500 mt-1">
                    {t("caseWillBeTransferredToSelectedZonalAdministration")}
                  </p>
                </div>
              )} */}

            {PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE ===
              formState.decision_type && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("decisionDate")} <span className="text-red-600">*</span>
                </label>
                <input
                  required
                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
                  type="date"
                  name="decision_date"
                  value={formState.decision_date}
                  onChange={handleChange}
                />
              </div>
            )}

            {PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE ===
              formState.decision_type && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {t("decisionSummary")} <span className="text-red-600">*</span>
                </label>
                <textarea
                  required
                  rows={4}
                  name="decision_summary"
                  value={formState.decision_summary}
                  onChange={handleChange}
                  placeholder={t("enterOfficialSummaryOfProsecutorDecision")}
                  className="w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-y"
                />
              </div>
            )}

            {PROSECUTOR_DECISION_TYPE2?.FRAME_CHARGE ===
              formState.decision_type && (
              <div>
                <section className="evidence-section">
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("chargeSummary")}
                    </label>
                    <textarea
                      required
                      rows={6}
                      name="charge_summary"
                      value={formState.charge_summary}
                      onChange={handleChange}
                      placeholder={t("detailsHere")}
                      className="w-full border bg-gray-100 rounded-md p-2 text-sm"
                    />
                  </div>

                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      {t("articleOfCharge")}
                    </label>
                    <textarea
                      required
                      rows={6}
                      name="charge_article"
                      value={formState.charge_article}
                      onChange={handleChange}
                      placeholder={t("detailsHere")}
                      className="w-full border bg-gray-100 rounded-md p-2 text-sm"
                    />
                  </div>
                </section>

                <section className="evidence-section">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {t("chargeFile")}
                  </label>
                  <div className="file-upload-area" onClick={triggerFileInput}>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      // multiple
                      style={{ display: "none" }}
                    />
                    <p className="upload-text">{t("uploadFiles")}</p>
                    {formState.files.length > 0 && (
                      <div className="file-list">
                        {formState.files.map((file, index) => (
                          <div key={index} className="file-item">
                            {file.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </section>
              </div>
            )}
          </div>
        </section>

        {/* Supporting Documents Section */}
        {PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE ===
          formState.decision_type && (
          <section className="space-y-4">
            <div className="flex items-center">
              <div className="h-5 w-1 bg-red-700 rounded-r mr-3"></div>
              <h3 className="text-base font-semibold text-gray-800">
                {t("supportingDocuments")}
              </h3>
            </div>

            <div className="pl-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                {t("uploadOfficialDecisionDocument")}
              </label>

              {/* File Upload Area */}
              <div
                className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:border-red-400 hover:bg-red-50 transition-colors cursor-pointer"
                onClick={triggerFileInput}
              >
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  style={{ display: "none" }}
                />
                <div className="flex flex-col items-center">
                  <div className="w-12 h-12 flex items-center justify-center bg-red-100 rounded-full mb-3">
                    <svg
                      className="w-6 h-6 text-red-600"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      />
                    </svg>
                  </div>
                  <p className="text-sm font-medium text-gray-700 mb-1">
                    {t("uploadSupportingDocuments")}
                  </p>
                  <p className="text-xs text-gray-500">
                    {t("fileTypesWithMax10mb")}
                  </p>
                </div>
              </div>

              {/* File List */}
              {formState.files.length > 0 && (
                <div className="mt-4 space-y-2">
                  <p className="text-sm font-medium text-gray-700">
                    {t("selectedDocuments")} ({formState.files.length})
                  </p>
                  <div className="space-y-2">
                    {formState.files.map((file, index) => (
                      <div
                        key={index}
                        className="flex items-center justify-between bg-gray-50 border border-gray-200 rounded-md px-3 py-2.5"
                      >
                        <div className="flex items-center space-x-3">
                          <div className="w-8 h-8 flex items-center justify-center bg-red-100 rounded">
                            <span className="text-xs font-medium text-red-700">
                              {file.type
                                .split("/")[1]
                                ?.substring(0, 3)
                                .toUpperCase() || "DOC"}
                            </span>
                          </div>
                          <div>
                            <p className="text-sm font-medium text-gray-800 truncate max-w-xs">
                              {file.name}
                            </p>
                            <p className="text-xs text-gray-500">
                              {(file.size / (1024 * 1024)).toFixed(2)} MB
                            </p>
                          </div>
                        </div>
                        <button
                          type="button"
                          onClick={() => removeFile(index)}
                          className="text-gray-400 hover:text-red-600 transition-colors"
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </section>
        )}

        {(formState.decision_type === "out of jurisdiction forward to zone" ||
          formState.decision_type ===
            "Forwarded to zone for further investigation") && (
          <div className="pl-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {t("comment")} <span className="text-red-600">*</span>
            </label>
            <textarea
              required
              rows={4}
              name="decision_summary"
              value={formState.decision_summary}
              onChange={handleChange}
              placeholder={t("enterOfficialSummaryOfProsecutorDecision")}
              className="w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-y"
            />
          </div>
        )}

        {/* Action Buttons */}
        <div className="pt-4 border-t border-gray-200">
          <div className="flex space-x-3">
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 text-sm font-medium rounded-md hover:bg-gray-50 transition-colors"
            >
              {t("cancel")}
            </button>
            <button
              type="submit"
              disabled={
                PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE ===
                formState.decision_type
                  ? loading ||
                    !formState.decision_date ||
                    !formState.decision_summary
                  : formState.decision_type ===
                        "out of jurisdiction forward to zone" ||
                      formState.decision_type ===
                        "Forwarded to zone for further investigation"
                    ? loading || !formState.decision_summary
                    : loading ||
                      !formState.charge_summary ||
                      !formState.charge_article ||
                      formState.files.length === 0
              }
              className={`flex-1 px-4 py-2.5 text-white text-sm font-medium rounded-md transition-colors flex items-center justify-center space-x-2 ${
                (
                  PROSECUTOR_DECISION_TYPE2?.CLOSE_THE_CASE ===
                  formState.decision_type
                    ? loading ||
                      !formState.decision_date ||
                      !formState.decision_summary
                    : formState.decision_type ===
                          "out of jurisdiction forward to zone" ||
                        formState.decision_type ===
                          "Forwarded to zone for further investigation"
                      ? loading || !formState.decision_summary
                      : loading ||
                        !formState.charge_summary ||
                        !formState.charge_article ||
                        formState.files.length === 0
                )
                  ? "bg-red-400 cursor-not-allowed"
                  : "bg-red-700 hover:bg-red-800"
              }`}
            >
              {loading ? (
                <>
                  {LoadingIcon}
                  <span>{t("processing")}</span>
                </>
              ) : (
                t("submitProsecutorDecision")
              )}
            </button>
          </div>
          <p className="text-xs text-gray-500 text-center mt-3">
            {t("officialProsecutorialDeterminationNote")}
          </p>
        </div>
      </form>
    </SideModal>
  );
}
